/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module } from '@msdyn365-commerce-modules/utilities';

import { IDlvryOverrideThemeVariablesData } from './dlvry-override-theme-variables.data';
import { IDlvryOverrideThemeVariablesProps } from './dlvry-override-theme-variables.props.autogenerated';

export interface IDlvryOverrideThemeVariablesViewProps extends IDlvryOverrideThemeVariablesProps<IDlvryOverrideThemeVariablesData> {}

/**
 *
 * DlvryOverrideThemeVariables component
 * @extends {React.PureComponent<IDlvryOverrideThemeVariablesProps<IDlvryOverrideThemeVariablesData>>}
 */
class DlvryOverrideThemeVariables extends React.PureComponent<IDlvryOverrideThemeVariablesProps<IDlvryOverrideThemeVariablesData>> {

    private baseClassName = 'dlvry-override-theme-variables';

    public render(): JSX.Element | null {
        const { config } = this.props;

        let variables = '';
        let headerVariables = '';

        if (config.accentColor) {
            variables += `--accent-color: ${config.accentColor};`;
        }

        if (config.accentBrandHoverColor) {
            variables += `--accent-hover-color: ${config.accentBrandHoverColor};`;
        }

        if (config.accentBrandPressedColor) {
            variables += `--accent-pressed-color: ${config.accentBrandPressedColor};`;
        }

        if (config.accentBrandSecondaryColor) {
            variables += `--accent-color-secondary: ${config.accentBrandSecondaryColor};`;
        }

        if (config.headerBackgroundColor) {
            variables += `--msv-header-bg: ${config.headerBackgroundColor};`;
            headerVariables += `--msv-header-bg: ${config.headerBackgroundColor};`;
        }

        if (config.headerFontColor) {
            variables += `--msv-header-font-color: ${config.headerFontColor};`;
            headerVariables += `--msv-header-font-color: ${config.headerFontColor};`;
        }

        const styleHtml: string | null = variables || headerVariables ? (
            `${variables ? `:root { ${variables} }` : ''}${headerVariables ? `body [data-m-t="header"] { ${headerVariables} }` : ''}`
        ) : null;

        return (
            <Module className={this.baseClassName} moduleProps={this.props}>
                {styleHtml ? (
                    <style dangerouslySetInnerHTML={{ __html: styleHtml }} />
                ) : null}
            </Module>
        );
    }
}

export default DlvryOverrideThemeVariables;
